import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

type B3ModalElement = HTMLElement & { open?: boolean };

@Component({
  standalone: false,
  selector: 'app-operation-confirmation-approve-modal',
  templateUrl: './operation-confirmation-approve-modal.component.html',
  styleUrls: ['./operation-confirmation-approve-modal.component.scss'],
})
export class OperationConfirmationApproveModalComponent {
  @ViewChild('approveModal') approveModal?: ElementRef<B3ModalElement>;

  @Input() open = false;

  @Output() closed = new EventEmitter<boolean>();

  onCancel(): void {
    this.closeModal(false);
  }

  onConfirm(): void {
    this.closeModal(true);
  }

  onModalDismiss(): void {
    this.closeModal(false);
  }

  private closeModal(confirmed: boolean): void {
    const modalHost = this.approveModal?.nativeElement;
    if (modalHost) {
      modalHost.open = false;
    }

    document.querySelectorAll('dialog[open]').forEach(element => {
      if (element instanceof HTMLDialogElement) {
        element.close();
      }
    });

    this.closed.emit(confirmed);
  }
}
